import { SwitchCity } from "@travelata-libs/travelata-frontend";

export function getPanelList(): (SwitchCity & { el: HTMLElement })[] {
    const lists = document.querySelector('.regionsPanelList')?.querySelectorAll('li') || [];
    const res: (SwitchCity & { el: HTMLElement })[] = [];
    lists.forEach((li) => {
        res.push({
            name: li.querySelector('a')?.getAttribute('title') || '',
            id: Number(li.dataset.id) || 0,
            url: li.querySelector('a')?.href || '',
            el: li,
        })
    });
    return res;
}

export function getCurrentCity(cities: SwitchCity[]): SwitchCity | null {
    const currentCity = cities.find((c) => c.name === document.querySelector('.regionSelect-js')?.textContent);
    return currentCity || null;
}
